import { createAsyncThunk } from "@reduxjs/toolkit";
import Sessions from "utils/Sessions";
import ApiService, { fetchAPIService } from "../ApiService/ApiService";

export const createInsuranceThunk = createAsyncThunk("insurance/create", async (data) => {
  const res = await ApiService.post("insurance", data, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const getAllInsuranceThunk = createAsyncThunk("insurance/getAll", async (param) => {
  const res = await ApiService.get(`insurance${param ? `?${param}` : ""}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);

  const params = new URLSearchParams(param);
  const page = params.get("page");
  return page === "0" || page === null
    ? { data: res?.data, type: "add", status: res?.status, byPassSlice: false }
    : { data: res?.data, type: "append", status: res?.status, byPassSlice: false };
});

export const getInsuranceByIdThunk = createAsyncThunk("insurance/getById", async (id) => {
  const res = await ApiService.get(`insurance/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const updateInsuranceThunk = createAsyncThunk(
  "insurance/update",
  async ({ id, data, body }) => {
    const payload = data || body;
    const res = await ApiService.patch(`insurance/${id}`, payload, {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    })
      .then((r) => r)
      .catch((error) => error.response);
    return res;
  }
);

export const deleteInsuranceThunk = createAsyncThunk("insurance/delete", async (id) => {
  const res = await ApiService.delete(`insurance/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const getInsuranceStatsThunk = createAsyncThunk("insurance/stats", async (param) => {
  const res = await ApiService.get(`insurance/stats${param ? `?${param}` : ""}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res?.data;
});

export const exportInsuranceThunk = createAsyncThunk("insurance/export", async (param) => {
  const res = await fetchAPIService(`insurance/export${param ? `?${param}` : ""}`, {
    method: "GET",
  }).then((response) => response.blob());
  return res;
});
